export const SUPPLIER_ORGANIZATION_NAME_MAX_LENGTH = 70

export function isSupplierOrganizationNameTooLong(name: string): boolean {
  return name.trim().length > SUPPLIER_ORGANIZATION_NAME_MAX_LENGTH
}

export function isSupplierOrganizationNameValid(name: string): boolean {
  const trimmed = name.trim()
  return trimmed.length > 0 && !isSupplierOrganizationNameTooLong(name)
}
